import React, { useEffect, useState } from 'react'
import T from 'prop-types'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { addDays } from 'date-fns'
import { isRepairSession } from 'lib/sessionLifecycle'

import ConfirmationDialog from 'components/atoms/ConfirmationDialog'
import StaticDatePicker from 'components/atoms/StaticDatePicker'

const noop = () => {}

export default function AssignmentConfirmationDialog({
  session,
  open,
  handleClose,
  handleSubmit,
  dateValue,
  setDateValue = noop,
}) {
  const { t } = useTranslation()

  const [startDateValue, setStartDateValue] = useState()
  const repairSession = isRepairSession(session)
  const copyKey = repairSession
    ? 'assignment.confirmationDialog.repair'
    : 'assignment.confirmationDialog'

  useEffect(() => {
    if (open) {
      const startDate = addDays(new Date(), 1)
      setDateValue(startDate)
      setStartDateValue(startDate)
    }
  }, [open, setDateValue])

  return (
    <ConfirmationDialog
      title={t(`${copyKey}.title`)}
      contentComponent={Box}
      content={
        <>
          <Typography variant="body2">{t(`${copyKey}.content`)}</Typography>
          <Box pb={3} />
          <Typography variant="body2">
            {t(`${copyKey}.datePicker.label`, {
              defaultValue: t('assignment.confirmationDialog.datePicker.label'),
            })}
          </Typography>
          <StaticDatePicker
            value={dateValue}
            onChange={setDateValue}
            minDate={startDateValue}
          />
        </>
      }
      open={open}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
    />
  )
}

AssignmentConfirmationDialog.propTypes = {
  session: T.object,
  open: T.bool,
  handleClose: T.func,
  handleSubmit: T.func,
  dateValue: T.instanceOf(Date),
  setDateValue: T.func,
}
